import * as invoice from "src/api/invoice";
import router from "src/router";
import { GET_INVOICE_HELPERS, SET_INVOICE } from "src/store/mutation-types";

const getInvoiceHelpers = ({ commit }) => {
  invoice.getHelpers().then((response) => {
    commit(GET_INVOICE_HELPERS, response);
  });
};

const setInvoice = ({ commit }, invoice) => {
  commit(SET_INVOICE, invoice);
};

const getInvoiceDetail = ({ commit, dispatch }, configs) => {
  dispatch("toggleLoadding", true, { root: true });
  invoice.getInvoice(configs.id, configs.params).then((response) => {
    if (response.code === 200) {
      dispatch("toggleLoadding", false, { root: true });
      commit(SET_INVOICE, response.data);
      if (configs.success != null) {
        configs.success(response.data);
      }
    } else if (response.code === 404) {
      dispatch("toggleLoadding", false, { root: true });
      dispatch(
        "showNotify",
        {
          title: "Không tìm thấy tài nguyên",
          body: "Phiếu chi không tồn tại trên hệ thống",
          type: "warning",
        },
        { root: true }
      );
      router.push({ name: "invoice" });
    } else {
    }
  });
};

export default {
  getInvoiceHelpers,
  setInvoice,
  getInvoiceDetail,
};



// WEBPACK FOOTER //
// ./src/components/invoice/store/actions.js